const rankingItems = [
  { rank: 1, title: '狂飙', type: '电视剧', hot: '987万热度', desc: '张译、张颂文主演反黑刑侦剧，年度现象级爆款', change: 'up' },
  { rank: 2, title: '满江红', type: '电影', hot: '865万热度', desc: '张艺谋导演悬疑喜剧，沈腾易烊千玺主演', change: 'up' },
  { rank: 3, title: '流浪地球2', type: '电影', hot: '792万热度', desc: '国产科幻巨制，视觉震撼口碑炸裂', change: 'up' },
  { rank: 4, title: '长相思', type: '电视剧', hot: '718万热度', desc: '杨紫主演古装神话剧，虐心又上头', change: 'down' },
  { rank: 5, title: '奔跑吧·生态篇', type: '综艺', hot: '653万热度', desc: '王牌综艺全新升级，笑点密集停不下来', change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热播排行榜</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">实时热度榜单，追踪全网最受欢迎的影视内容，发现大家都在看什么</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-accent-300 transition-all duration-200 cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg font-bold text-lg font-heading ${
                item.rank === 1 ? 'bg-accent-500 text-white' :
                item.rank === 2 ? 'bg-accent-400 text-white' :
                item.rank === 3 ? 'bg-accent-300 text-white' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">{item.type}</span>
                  {item.change === 'up' && <i className="ri-arrow-up-fill text-green-500 text-xs"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-fill text-red-400 text-xs"></i>}
                  {item.change === 'new' && <span className="text-xs text-accent-500 font-medium whitespace-nowrap">NEW</span>}
                </div>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="text-sm font-bold text-accent-600 whitespace-nowrap">{item.hot}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}